export default "__VITE_ASSET__C0K4GGDR__"